const title = {
    report: 'Báo cáo',
    add: 'Thêm',
    update: 'Sửa',
    dashboard: 'Trang chủ',
    notFound: 'Không tìm thấy',
    conditionPromotion: 'Điều kiện khuyến mãi',
    vaccine: 'Vaccine',
    typeOfVaccine: 'Loại vaccine',
    customer: 'Khách hàng',
    customerType: 'Loại khách hàng',
    permission: 'Chức vụ',
    staff: 'Nhân viên',
    supplier: 'Nhà cung cấp',
    shipment: 'Lô vaccine',
    vaccinePrice: 'Giá vaccine',
    vaccinePackage: 'Gói vaccine',
    regulationCustomer: 'Quy định khách hàng',
    screeningExamination: 'Khám sàn lọc',
    paymentMethod: 'Hình thức thanh toán',
    pay: 'Thanh toán',
    injectionSchedule: 'Lịch tiêm',
    injectionIncident: 'Sự cố tiêm',
    regulationInjection: 'Quy định tiêm',
    customerRank: 'Xếp loại khách hàng',
    customerRankDetail: 'Chi tiết xếp loại khách hàng',
    order: 'Đơn đặt hàng',
    entrySlip: 'Phiếu nhập',
    promotion: 'Khuyến mãi',
    auth: 'Đăng nhập',
    account: 'Tài khoản',
    loginSession: 'Phiên đăng nhập',
    statistical: 'Thống kê',
    permissionDetail: 'Phân quyền',
};
export default title;
